import { useContract } from '@thirdweb-dev/react';
import { useConfig } from '@app/config';

import nftMarketplaceAbi from 'abis/NFTMarketPlace.json';
import { useAsyncFn } from 'react-use';

export function useEncodeUserBid() {
  const config = useConfig();

  const { contract } = useContract(
    config?.CONTRACTS.NFT_MARKETPLACE,
    nftMarketplaceAbi
  );

  const [{ value }, encodeUserBid] = useAsyncFn(
    async (
      amount: string,
      address: string,
      tokenId: string,
      nftAddress: string
    ) => {
      if (!contract) {
        return;
      }

      return await contract.call('encodeUserBid', [
        amount,
        address,
        tokenId,
        nftAddress
      ]);
    },
    [contract]
  );

  return {
    encodeUserBid
  };
}
